import { render, staticRenderFns } from "./ReporteBI.vue?vue&type=template&id=0784cef9&scoped=true&"
import script from "./ReporteBI.vue?vue&type=script&lang=js&"
export * from "./ReporteBI.vue?vue&type=script&lang=js&"
import style0 from "./ReporteBI.vue?vue&type=style&index=0&id=0784cef9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784cef9",
  null
  
)

export default component.exports